import React, { useState, useEffect } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

const ImageUploader = ({ label, onChange, onDelete, imageUrl, compressionOptions }) => {
  const [isLightboxOpen, setLightboxOpen] = useState(false);
  const [compressedImageUrl, setCompressedImageUrl] = useState(imageUrl);

  useEffect(() => {
    if (imageUrl) {
      setCompressedImageUrl(imageUrl);
    }
  }, [imageUrl]);

  const compressImage = async (file) => {
    try {
      const compressedImage = await window.imageCompression(file, compressionOptions);
      setCompressedImageUrl(URL.createObjectURL(compressedImage));
      onChange(compressedImage);
    } catch (error) {
      console.error('Error compressing image:', error);
    }
  };

  const handleFileChange = async (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];

      if (!['image/png', 'image/jpeg', 'image/jpg', 'image/webp'].includes(file.type)) {
        alert('Please upload an image');
        return;
      }

      compressImage(file);
    }
  };

  const handleDeleteClick = () => {
    setCompressedImageUrl(null);
    onChange(null);
    onDelete();
  };

  const handlePreviewClick = () => {
    setLightboxOpen(true);
  };

  return (
    <div className="image-upload" style={{margin:"10px 0px",  display: compressedImageUrl ? 'block' : 'none' }}>
      <label htmlFor="image" className="input_label">
        {label}
        <br />
      </label>
      <div className="form-group multi-preview" style={{ marginTop: '10px', visibility: compressedImageUrl ? 'visible' : 'hidden' }}>
        <span className="thumbnail">
          <img src={compressedImageUrl} onClick={handlePreviewClick} alt="no image" />
          <a>
            <i className="far fa-times-circle" onClick={handleDeleteClick}></i>
          </a>
        </span>
        <span className="ril__builtinButton">
          {isLightboxOpen && (
            <Lightbox mainSrc={compressedImageUrl} onCloseRequest={() => setLightboxOpen(false)} />
          )}
        </span>
      </div>
      {/* <input
        id="image"
        type="file"
        name="image"
        onChange={handleFileChange}
        autoComplete="off"
      /> */}
    </div>
  );
};

export default ImageUploader;
